import React, { createContext, useState, useContext } from 'react';
import { useFilterTimeMetric } from 'clientState/hooks/metrics';
import { useOrderFilterTagsActions } from 'clientState/providers/OrderedFilterTagsProvider';

type PrimeDayFilterContextType = {
  hasPrimeDayFilterApplied: boolean;
  togglePrimeDayFilter: () => void;
  resetPrimeDayFilter: () => void;
};

const PrimeDayFilterContext = createContext<PrimeDayFilterContextType>(
  {} as PrimeDayFilterContextType
);
const { Provider } = PrimeDayFilterContext;

export const usePrimeDayFilter = () => useContext(PrimeDayFilterContext);

const PrimeDayFilter: React.FC = ({ children }) => {
  const { start } = useFilterTimeMetric();
  const { add, remove } = useOrderFilterTagsActions();
  const [hasPrimeDayFilterApplied, setPrimeDayFilter] = useState(false);

  const applyPrimeDayFilter = (value: boolean) => {
    start();
    setPrimeDayFilter(value);
    if (value) {
      add({
        alias: 'airline',
        type: 'primeDay',
        undo: () => {
          setPrimeDayFilter(false);
          remove({ alias: 'primeDay' });
        },
      });
    } else {
      remove({ alias: 'airline' });
    }
  };

  const value = {
    hasPrimeDayFilterApplied,
    togglePrimeDayFilter: () => applyPrimeDayFilter(!hasPrimeDayFilterApplied),
    resetPrimeDayFilter: () => applyPrimeDayFilter(false),
  };

  return <Provider value={value}>{children}</Provider>;
};

export default PrimeDayFilter;
